import { useTypesStore } from "../store/Types.js";
import { useTypesRender } from "../utils/useRender.js";
export var Float = props => {
  var {
    Float: Comp = {}
  } = useTypesStore();
  useTypesRender(Comp, props, 'Float');
  return null;
};
Float.displayName = 'JVR.Float';